import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import i18n from "./i18n";

// 根据环境变量 VUE_APP_USE_MOCK 的值决定是否加载 mockjs
if (process.env.VUE_APP_USE_MOCK === "true") {
  require("@/mock"); // @ 指向 src 目录
  console.log("Mocking is enabled.");
}

// 只在开发环境中启用，避免打包到生产环境
if (process.env.NODE_ENV === "development") {
  const eruda = require("eruda");
  eruda.init();
}

Vue.config.productionTip = false;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
